<template>
    <InertiaLink :href="message.deliveryInfo != null ? route('viewDeliveryInfo', {id: message.deliveryInfo.id}) : '#'" @click.stop=""
                 :class="'bg-'+ statuses.colors[message.deliveryInfo ? message.deliveryInfo.GetDeliveryInfoResponse.dmDelivery.dmMessageStatus : 0] +'-100 ' +
                                                        'hover:bg-' + statuses.colors[message.deliveryInfo ? message.deliveryInfo.GetDeliveryInfoResponse.dmDelivery.dmMessageStatus : 0] +'-200 ' +
                                                        'text-'+ statuses.colors[message.deliveryInfo ? message.deliveryInfo.GetDeliveryInfoResponse.dmDelivery.dmMessageStatus : 0] +'-800'"
                 class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full uppercase"
                 v-tooltip="statuses.long[message.deliveryInfo ? message.deliveryInfo.GetDeliveryInfoResponse.dmDelivery.dmMessageStatus : 0]">
        {{ statuses.short[message.deliveryInfo ? message.deliveryInfo.GetDeliveryInfoResponse.dmDelivery.dmMessageStatus : 0] }}
    </InertiaLink>
</template>

<script>
import { Link } from '@inertiajs/inertia-vue3'
export default {
    name: "MessagesTableRowStatusBadge",
    components: { InertiaLink: Link },
    props: ['message'],
    data(){
        return {
            statuses: this.$page.props.statuses,
        }
    }
}
</script>

<style scoped>

</style>
